import type { LeadsListFilters, LeadSummary } from 'app/features/leads/services/gym-finder/types';

export const filterLeads = (leads: LeadSummary[], filters: LeadsListFilters): LeadSummary[] => {
  const search = filters.search.trim().toLowerCase();

  return leads.filter((lead) => {
    if (filters.status !== 'all' && lead.status !== filters.status) {
      return false;
    }
    if (!search) {
      return true;
    }
    return lead.athleteName.toLowerCase().includes(search) || lead.athleteEmail.toLowerCase().includes(search);
  });
};
